import { buildStaffMenu } from "./staffMenu"
// Also available for Procurement-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Procurement role menu — cloned from the shared staff base.
 *
 * Currently mirrors the staff base exactly. To add Procurement-specific overrides
 * without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildProcurementMenu = () => buildStaffMenu()
